<template>
  <div
    class="container v-content-container tooltip-wrapper"
    :key="componentKey"
  >
    <div class="row tooltip-wrapper">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-user fa-fw fa-lg"></i>
          {{ $label("customer.contact_persons", "Contact persons") }}
          <router-link
            :to="{ name: 'NewCustomerContact' }"
            v-tooltip="{
              content: $label(
                'customer.new_contact_person',
                'New contact person'
              ),
              classes: 'custom-tooltip'
            }"
            class="btn btn-v-lightgreen-white pull-right"
          >
            <i class="fa fa-fw fa-lg fa-plus"></i>
          </router-link>
        </h1>
      </div>
    </div>
    <input type="hidden" id="customer-display-all" value="false" />

    <navigation-tabs :customer-id="selectedCustomerId"></navigation-tabs>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <div class="row">
        <div class="col-sm-3 col-xs-6">
          <div id="action-dropdown" class="btn-group">
            <button
              type="button"
              class="btn btn-primary dropdown-toggle"
              data-toggle="dropdown"
            >
              <i class="fa fa-refresh"></i> &nbsp;
              {{ $label("common.actions", "Actions") }} &nbsp;<span
                class="caret"
              ></span>
            </button>
            <ul class="dropdown-menu" role="menu">
              <li>
                <router-link :to="{ name: 'NewCustomerContact' }"
                  ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
                  {{
                    $label(
                      "customer.new_contact_person_long",
                      "Create new contact person"
                    )
                  }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="col-sm-3 col-xs-6 text-right">
          <div id="table-customers-search">&nbsp;</div>
          <input
            type="text"
            v-model="searchFilter"
            aria-controls="table-customers"
            class="form-control input-small customer-search-input"
            :placeholder="$label('common.search_placeholder', 'Search ...')"
            v-tooltip="{
              content: $label(
                'customer.contact_person_search',
                'Name or Email'
              ),
              classes: 'custom-tooltip'
            }"
          />
        </div>
      </div>

      <div class="row mt-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>

      <alert-box
        v-show="contactPersonsLength < 1 && contactPersonsLength != null"
        type="warning"
        id="alert-no-contact-persons"
        :closeable="false"
        :show-icon="false"
      >
        {{
          $label(
            "customer.no_contact_persons_exist",
            "No contact persons exist."
          )
        }}
      </alert-box>

      <alert-box
        v-show="failedRequest"
        class="mt-8"
        type="warning"
        :closeable="false"
        :show-icon="false"
      >
        {{
          $label(
            "customer.contact_persons_failed_request",
            "Request failed while loading contact persons."
          )
        }}
      </alert-box>

      <div
        v-show="
          contactPersonsLength > 0 &&
            contactPersonsLength != null &&
            !failedRequest
        "
        class="row"
      >
        <div class="col-xs-12">
          <div class="popup-wrapper">
            <div class="table-responsive">
              <fieldset>
                <input
                  id="customer-contact-status"
                  type="hidden"
                  name="customer_status"
                  value="customer-status"
                />
                <table
                  class="table dataTable table-striped table-bordered table-hover mb-1"
                  id="table-customer-contact-persons"
                >
                  <thead>
                    <tr>
                      <th
                        class="v-align-center text-center table-checkbox text-center v-form v-form-disable checkbox-fixed-width"
                      >
                        <label class="hidden-xs checkbox v-table-checkbox">
                          <input
                            type="checkbox"
                            class="group-checkable v-table-checkbox"
                            data-set="#table-customer-contact-persons .checkboxes"
                          /><i></i>
                        </label>
                      </th>
                      <th class="table-customer-contact-person-name">
                        {{ $label("common.name", "Name") }}
                      </th>
                      <th
                        class="table-customer-contact-person-email text-center"
                      >
                        {{ $label("common.email", "Email") }}
                      </th>
                      <th
                        class="table-customer-contact-person-phone-number text-center"
                      >
                        {{ $label("common.phone_number", "Phone number") }}
                      </th>
                      <th
                        class="table-customer-contact-person-gender text-center"
                      >
                        {{ $label("common.gender", "Gender") }}
                      </th>
                      <th class="table-customer-contact-position text-center">
                        {{ $label("common.position", "Position") }}
                      </th>
                      <th
                        class="table-customer-contact-position-actions text-center"
                      >
                        {{ $label("common.actions", "Actions") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="contactPerson in contactPersons"
                      v-bind:key="contactPerson.id"
                    >
                      <td
                        class="v-align-center v-table v-form v-form-disable sorting_1"
                      >
                        <label
                          class="hidden-xs checkbox v-table-checkbox-label"
                        >
                          <input
                            type="checkbox"
                            class="checkboxes v-table-checkbox"
                            name="selected_account_ids[]"
                            value="$id"
                          /><i></i>
                        </label>
                      </td>
                      <td
                        class="v-align-center"
                        :id="'contact-person-name-' + contactPerson.id"
                      >
                        <router-link
                          :to="{
                            name: 'CustomerContactDetails',
                            params: {
                              customer_id: selectedCustomerId,
                              contact_person_id: contactPerson.id
                            }
                          }"
                          class="font-color-table"
                          v-tooltip.top-center="
                            '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><i class=&quot;text-primary fa fa-lg fa-fw fa-info-circle&quot;></i><b>' +
                              $label('common.groups', 'Groups') +
                              '</b></p></div>' +
                              '<p class=&quot;tooltip-content&quot;>' +
                              $label(
                                'customer.no_assignment_existing',
                                'No assignment existing'
                              ) +
                              '</p>'
                          "
                        >
                          {{
                            beautifyName(
                              contactPerson.first_name,
                              contactPerson.last_name
                            )
                          }}
                        </router-link>
                      </td>
                      <td
                        class="v-align-center"
                        :id="'contact-person-email-' + contactPerson.id"
                      >
                        {{ contactPerson.email }}
                      </td>
                      <td
                        class="v-table v-align-center text-center"
                        :id="'contact-person-phone-number-' + contactPerson.id"
                      >
                        <div
                          v-show="
                            contactPerson.phone_number.prefix != null &&
                              contactPerson.phone_number.number != null
                          "
                          v-tooltip.top-center="
                            '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><i class=&quot;text-primary fa fa-lg fa-fw fa-user&quot;></i> <b>' +
                              beautifyName(
                                contactPerson.first_name,
                                contactPerson.last_name
                              ) +
                              '</b></p></div>' +
                              '<i class=&quot;text-v-green fa  fa-lg fa-fw fa-mobile&quot;></i>+' +
                              contactPerson.phone_number.prefix +
                              '' +
                              contactPerson.phone_number.number +
                              '<br><i class=&quot;text-v-green fa fa-lg fa-fw fa-phone&quot;></i> <br><i class=&quot;text-v-green fa fa-lg fa-fw fa-tag&quot;></i> '
                          "
                        >
                          <i class="text-primary fa fa-lg fa-fw fa-mobile"></i>
                          +{{ contactPerson.phone_number.prefix
                          }}{{ contactPerson.phone_number.number }}
                        </div>
                      </td>
                      <td
                        class="v-align-center text-center"
                        :id="'contact-person-gender-' + contactPerson.id"
                      >
                        {{ getGenderName(contactPerson.gender) }}
                      </td>
                      <td
                        class="v-align-center text-center"
                        :id="'contact-person-department-' + contactPerson.id"
                      >
                        {{ contactPerson.department }}
                      </td>
                      <td class="text-center text-center min-width-auto">
                        <div class="btn-group">
                          <router-link
                            :to="{
                              name: 'CustomerContactDetails',
                              params: {
                                customer_id: selectedCustomerId,
                                contact_person_id: contactPerson.id
                              }
                            }"
                            v-tooltip="{
                              content: $label('common.details', 'Details'),
                              classes: 'custom-tooltip'
                            }"
                            class="btn btn-sm btn-default"
                            ><i class="text-primary fa fa-fw fa-eye"></i>
                            {{
                              $label("common.details", "Details")
                            }}</router-link
                          >
                          <a
                            @click="
                              deleteCustomerContactPerson(contactPerson.id)
                            "
                            :id="
                              'delete-contact-person-button-' + contactPerson.id
                            "
                            data-id="contactPersonId"
                            class="btn btn-sm btn-danger"
                            ><i class="fa fa-fw  fa-lg fa-trash-o"></i>
                            {{ $label("common.delete", "Delete") }}</a
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div class="row mb-8">
        <div class="col-xs-12">&nbsp;</div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api";
import ViewLoader from "@/components/Common/ViewLoader";
import NavigationTabs from "@/components/Customers/Customer/NavigationTabs";
import AlertBox from "@/components/Common/Alerts/AlertBox";
import Error404 from "@/components/Common/Error404";

import swal from "sweetalert";

export default {
  name: "CustomerContacts",

  components: {
    ViewLoader,
    AlertBox,
    NavigationTabs,
    Error404
  },

  data() {
    return {
      componentKey: 0,
      contactPersons: [],
      loading: false,
      updating: false,
      noDataExist: false,
      contactPersonsLength: null,
      failedRequest: false,
      currentPage: 1,
      total: 0,
      from: 0,
      to: 0,
      firstPage: 1,
      lastPage: null,
      perPage: null,
      searchFilter: "",
      selectedCustomerId: null
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedCustomerId = vm.$route.params.customer_id;
      if (
        vm.$route.query.contact_person_deleted === true ||
        vm.$route.query.contact_person_deleted === "true"
      ) {
        swal("Success!", "The contact person was deleted.", "success").then(
          () => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }
        );
      }
      vm.getCustomerContactPersons(() => {
        //
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.contact_person_deleted === true) {
      swal("Success!", "The contact person was deleted.", "success").then(
        () => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        }
      );
    }
    this.forceRerender();
    if (this.to % this.perPage === 1 && this.currentPage !== 1) {
      this.currentPage -= 1;
    }
    this.getCustomerContactPersons(() => {
      //
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    getCustomerContactPersons(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.customers = [];
      const endpoint = this.$partnerEndpoint(
        "customers/" + this.selectedCustomerId + "/contact-persons"
      );

      Api()
        .get(endpoint)
        .then(response => {
          this.contactPersons = response.data.data;
          /*this.currentPage = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                    if (response.data.meta.from != null) {
                        this.from = response.data.meta.from;
                    } else {
                        this.from = 0;
                    }
                    if (response.data.meta.to != null) {
                        this.to = response.data.meta.to;
                    } else {
                        this.to = 0;
                    }
                    this.lastPage = response.data.meta.last_page;
                    this.perPage = response.data.meta.per_page;*/
          this.contactPersonsLength = this.contactPersons.length;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteCustomerContactPerson(contactPersonId) {
      if (
        this.loading ||
        this.updating ||
        this.selectedCustomerId == null ||
        contactPersonId == null
      ) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The contact person will be deleted.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "customers/" +
              this.selectedCustomerId +
              "/contact-persons/" +
              contactPersonId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router
                .push({
                  name: "CustomerContacts",
                  query: { contact_person_deleted: true }
                })
                .catch(error => {
                  console.log(error);
                  if (
                    error.name === "NavigationDuplicated" ||
                    error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    swal(
                      "Success!",
                      "The contact person was deleted.",
                      "success"
                    );
                    this.getCustomerContactPersons(() => {
                      //
                    });
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete contact persons.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    goToFirstPage() {
      if (!this.disabledFirstPage) {
        this.currentPage = 1;
        this.getCustomerContactPersons(() => {
          //
        });
      }
    },

    goToPreviousPage() {
      if (!this.disabledPreviousPage) {
        this.currentPage--;
        this.getCustomerContactPersons(() => {
          //
        });
      }
    },

    goToNextPage() {
      if (!this.disabledNextPage) {
        this.currentPage++;
        this.getCustomerContactPersons(() => {
          //
        });
      }
    },

    goToLastPage() {
      if (!this.disabledLastPage) {
        this.currentPage = this.lastPage;
        this.getCustomerContactPersons(() => {
          //
        });
      }
    },

    forceRerender() {
      this.componentKey += 1;
    }
  },

  computed: {
    disabledFirstPage() {
      return this.currentPage === 1;
    },

    disabledPreviousPage() {
      return this.currentPage === 1;
    },

    disabledNextPage() {
      return this.currentPage === this.lastPage;
    },

    disabledLastPage() {
      return this.currentPage === this.lastPage;
    }
  },

  watch: {
    searchFilter() {
      this.getCustomerContactPersons(() => {
        //
      });
    }
  }
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0rem;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.checkbox-fixed-width {
  width: 50px;
}

.v-table-checkbox-label {
  margin-left: 10px;
}

.v-table-checkbox {
  position: relative !important;
}

.min-width-auto {
  width: 50px;
}

.customer-search-input {
  width: 60% !important;
  display: inline;
}

.customer-search-button {
  margin-bottom: 4px;
  padding: 5px 12px;
  margin-left: 5px;
}
</style>
